// Profile name validation function (centralized)
export const validateProfileName = (value: string) => {
  if (!value || value.trim() === '') {
    return 'Profile name is required'
  }
  const trimmedValue = value.trim()
  if (trimmedValue.length < 2) {
    return 'Profile name must be at least 2 characters long'
  }
  if (trimmedValue.length > 20) {
    return 'Profile name must be no more than 20 characters long'
  }
  return true
}
